import { createFileRoute } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

function makeFaqSchema(t: { faq_q1: string; faq_a1: string; faq_q2: string; faq_a2: string; faq_q3: string; faq_a3: string; faq_q4: string; faq_a4: string; faq_q5: string; faq_a5: string; faq_q6: string; faq_a6: string; faq_q7: string; faq_a7: string; faq_q8: string; faq_a8: string }) {
  const pairs = [
    { q: t.faq_q1, a: t.faq_a1 },
    { q: t.faq_q2, a: t.faq_a2 },
    { q: t.faq_q3, a: t.faq_a3 },
    { q: t.faq_q4, a: t.faq_a4 },
    { q: t.faq_q5, a: t.faq_a5 },
    { q: t.faq_q6, a: t.faq_a6 },
    { q: t.faq_q7, a: t.faq_a7 },
    { q: t.faq_q8, a: t.faq_a8 },
  ];
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: pairs.map((qa) => ({
      "@type": "Question",
      name: qa.q,
      acceptedAnswer: { "@type": "Answer", text: qa.a },
    })),
  };
}

export const Route = createFileRoute("/$lang/faq")({
  head: ({ params }) => ({
    meta: [
      { title: "FAQ — MadCaptains" },
      { name: "description", content: "Anonymity, moderation, AI, languages, takedown, and who keeps the lighthouse on." },
      { property: "og:url", content: `/${params.lang}/faq` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/faq` }],
  }),
  component: FaqPage,
});

function FaqPage() {
  const { t } = useI18n();
  const pairs = [
    { q: t.faq_q1, a: t.faq_a1 },
    { q: t.faq_q2, a: t.faq_a2 },
    { q: t.faq_q3, a: t.faq_a3 },
    { q: t.faq_q4, a: t.faq_a4 },
    { q: t.faq_q5, a: t.faq_a5 },
    { q: t.faq_q6, a: t.faq_a6 },
    { q: t.faq_q7, a: t.faq_a7 },
    { q: t.faq_q8, a: t.faq_a8 },
  ];
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(makeFaqSchema(t)) }}
      />
      <PageShell eyebrow={t.page_faq_h1} title={t.page_faq_h1} lead={t.page_faq_lead}>
        <dl className="divide-y divide-border border-y border-border">
          {pairs.map((qa, i) => (
            <div key={i} className="py-6">
              <dt className="font-display text-lg">{qa.q}</dt>
              <dd className="mt-2 text-justify text-muted-foreground">{qa.a}</dd>
            </div>
          ))}
        </dl>
      </PageShell>
    </>
  );
}
